import { render, staticRenderFns } from "./recharge1.vue?vue&type=template&id=33a8d3ba&scoped=true"
import script from "./recharge1.vue?vue&type=script&lang=js"
export * from "./recharge1.vue?vue&type=script&lang=js"
import style0 from "./recharge1.vue?vue&type=style&index=0&id=33a8d3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8d3ba",
  null
  
)

export default component.exports